<template>
  <div class="columns store-menu-list">
    <div class="column">
      <div class="store-menu-list__header">
        <h2 class="store-menu-list__header--title">菜單列表</h2>
        <router-link
          v-if="menus.length"
          :to="pathToCreateMenu"
          :disabled="disabled"
          tag="button"
          class="button is-primary">
          <i class="icon-plus mr-2" />
          新增菜單
        </router-link>
      </div>
      <div class="store-menu-list__list">
        <div v-for="(menu, index) in menus" :key="menu.id" @click="editMenu(menu.id)">
          <div class="store-menu-list__item">
            <div class="store-menu-list__item--index">{{ index + 1 }}.</div>
            <div class="store-menu-list__item--name">
              <span>{{ menu.name }}</span>
            </div>
            <div class="store-menu-list__item--last-update">
              <h3>最後更新</h3>
              <span>{{ formatTime(menu.updated_at) }}</span>
            </div>
          </div>
          <hr class="my-4">
        </div>

        <div
          v-if="!menus.length"
          class="store-menu-list__empty is-flex is-align-items-center">
          <router-link
            :to="pathToCreateMenu"
            :disabled="disabled"
            class="button is-primary"
            tag="button">
            前往建立菜單
          </router-link>
          <p class="store-menu-list__empty--description">
            <template v-if="isEditMode">
              該店家尚未有菜單，儘速前往新增菜單唷！
            </template>
            <template v-else>
              店家資訊儲存後才能開始建立菜單。
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuList from './MenuList';

export default MenuList;
</script>

<style lang="scss" scoped>
@import 'MenuList';
</style>
